import {AccessManagementConfig} from './access-management';
import {CommonAbilities} from './common-abilities';

export const commonAccessManagementConfig: AccessManagementConfig<CommonAbilities> = {
  Account: {
    actions: ['create', 'read', 'update', 'delete', 'manage', 'assignRole'],
    fields: [
      {name: 'id', type: 'id'},
      {name: 'email', type: 'email'},
      {name: 'tenantId', type: 'id'},
      {name: 'firstName', type: 'string'},
      {name: 'lastName', type: 'string'},
      {name: 'language', type: 'string'},
      {name: 'country', type: 'string'},
      {name: 'verified', type: 'boolean'},
      {name: 'hasPassword', type: 'boolean'},
      {name: 'roles', type: 'string'},
    ],
  },
  AccountImage: {
    actions: ['create', 'read', 'update', 'delete', 'manage'],
    fields: [
      {name: 'id', type: 'id'},
      {name: 'accountId', type: 'id'},
      {name: 'tenantId', type: 'id'},
      {name: 'url', type: 'string'},
    ],
  },
  Role: {
    actions: ['create', 'read', 'update', 'delete', 'manage'],
    fields: [
      {name: 'tenantId', type: 'id'},
      {name: 'isSystemRole', type: 'boolean'},
      {name: 'status', type: 'enum', enumValues: ['active', 'inactive', 'suspended']},
      {
        name: 'metadata',
        type: 'string',
        children: [
          {name: 'createdBy', type: 'id'},
          {name: 'updatedBy', type: 'id'},
        ],
      },
    ],
  },
  Stub: {
    actions: ['stubAction'],
    fields: [],
    hidden: true,
  },
};
